import type { CountryRes } from 'api/swagger';

export const findCountriesById = (id?: number | null, countries?: CountryRes[]): CountryRes | undefined => {
  if (!countries || !id) return undefined;

  return countries?.find((country) => country.id === id);
};
